import { SegmentSchema } from '@sondermind/segment';
import { IPslPageLoadEventData } from './segment-event-data.interface';

export enum PslSegmentEvents {
  PSL_PAGE_VIEW = 'Viewed a provider shareable link page',
  AI_CONNECT_MODULE_VIEWED = 'AI Connect Module Viewed',
  AI_CONNECT_MODULE_START_BUTTON_CLICKED = 'AI Connect Module Start Button Clicked',
  AI_CONNECT_MESSAGE_SENT = 'AI Connect Message Sent',
  AI_CONNECT_EXIT = 'AI Connect Exit'
}

export enum AiConnectProjectType {
  PSL = 'PSL',
  PROVIDER_DIRECTORY = 'provider_directory'
}

export interface IAiConnectModuleViewedEvent {
  project: AiConnectProjectType;
}

export interface IAiConnectModuleStartButtonClickedEvent {
  project: AiConnectProjectType;
  selectedPills: string[];
}

export interface IAiConnectMessageSentEvent {
  project: AiConnectProjectType;
  messageCount: number;
}

export interface IAiConnectExitEvent {
  project: AiConnectProjectType;
}

export interface IPslSegmentSchema extends SegmentSchema {
  [PslSegmentEvents.PSL_PAGE_VIEW]: IPslPageLoadEventData;
  [PslSegmentEvents.AI_CONNECT_MODULE_VIEWED]: IAiConnectModuleViewedEvent;
  [PslSegmentEvents.AI_CONNECT_MODULE_START_BUTTON_CLICKED]: IAiConnectModuleStartButtonClickedEvent;
  [PslSegmentEvents.AI_CONNECT_MESSAGE_SENT]: IAiConnectMessageSentEvent;
  [PslSegmentEvents.AI_CONNECT_EXIT]: IAiConnectExitEvent;
}
